import {
    CqmMeasureDto,
    QrdaExportRunDto,
} from '@medone/medonehp-api-client';

// Re-export the enums + DTOs the rest of the feature needs so components stay decoupled
// from the generated package's name.
export {
    QrdaCohortTypes,
    QrdaExportPatientStatuses,
    QrdaExportRunStatuses,
    QrdaPackagingOptions,
} from '@medone/medonehp-api-client';

export type {
    CqmMeasureDto,
    CreateQrdaExportRunRequest,
    CreateSinglePatientRunRequest,
    QrdaExportRunDto,
    QrdaExportRunPatientDto,
    QrdaExportRunsSearchDto,
    QrdaMeasurePackagingDto,
} from '@medone/medonehp-api-client';

export interface ReportingPeriodOption {
    year: number;
    startDate: string;
    endDate: string;
    label: string;
}

export interface QualityReportingState {
    loading: boolean;
    processing: boolean;
    errorMessage: string | null;
    runs: QrdaExportRunDto[];
    runsTotal: number;
    currentRun: QrdaExportRunDto | null;
    cqmMeasures: CqmMeasureDto[];
}

export const initialQualityReportingState: QualityReportingState = {
    loading: false,
    processing: false,
    errorMessage: null,
    runs: [],
    runsTotal: 0,
    currentRun: null,
    cqmMeasures: [],
};
